import styles from "./button-icon.module.scss";
import { Button, ButtonProps } from "../button";
import { forwardRef, PropsWithChildren } from "react";
import classNames from "classnames";

export const ButtonIcon = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      className,
      variant = "tertiary-black",
      ...rest
    }: PropsWithChildren<ButtonProps>,
    ref,
  ) => {
    const classes = classNames(styles.icon, className);
    return (
      <Button {...rest} className={classes} variant={variant} ref={ref}>
        {children}
      </Button>
    );
  },
);

ButtonIcon.displayName = "ButtonIcon";
